<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="participationRequestModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="participationRequestModalLabel">{{$t('participationConfirmation.modalTitle')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ConfirmationDetailsCard v-model="model"
                                         v-if="showDetails"
                                         @cancel="onCancel">
                    </ConfirmationDetailsCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { AccommodationRequestDeatilsModel } from '../../../../models/models';
    import ConfirmationDetailsCard from './ConfirmationDetailsCard';
    import tempRankingService from '../../../../services/tempRanking.service';

    export default {
        components: {
            ConfirmationDetailsCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                showDetails: false,
                model: new AccommodationRequestDeatilsModel(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new AccommodationRequestDeatilsModel();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            },
            loadRankingConfirmationDeatils(id) {
                return new Promise((resolve, reject) => {
                    if (!id) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject();
                    }

                    tempRankingService.getRankingConfirmationDetails(id)
                        .then(response => {
                            resolve(response.data)
                        })
                        .catch(error => {
                            reject(error)
                        });
                });
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.loadRankingConfirmationDeatils(this.value.rankingConfirmationId)
                        .then(data => {
                            this.model = new AccommodationRequestDeatilsModel(this.value);
                            this.model.isNotifiedByPhone = data.isNotifiedByPhone;
                            this.model.dateOfNotificationUtc = data.dateOfNotificationUtc;
                            this.model.phoneOfNotificatiob = data.phoneOfNotificatiob;
                        }).catch(error => {
                            this.model = new AccommodationRequestDeatilsModel(this.value);
                        }).then(() => { this.showDetails = true });

                    // this.model = new AccommodationRequestDeatilsModel(this.value);
                    // this.showDetails = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
